// extracted by mini-css-extract-plugin
export default {"container":"auth-page-module__container___spGia","isPartnerFlow":"auth-page-module__isPartnerFlow___dlImT"};